import type { LucideIcon } from "lucide-react";

import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
} from "@krea/shared/design-system/sidebar";
import { cn } from "@krea/shared/utils";

interface IItem {
  title: string;
  onClick?: () => void;
  icon?: LucideIcon;
  isActive?: boolean;
  items?: Omit<IItem, "items">[];
}

interface IProps {
  items: IItem[];
}

export const NavGroup = ({ items }: IProps) => {
  return (
    <SidebarGroup>
      <SidebarMenu>
        {items.map((item) => (
          <SidebarMenuItem key={item.title}>
            <SidebarMenuButton
              tooltip={item.title}
              isActive={item.isActive}
              onClick={item.onClick}
              className={cn(
                !item.onClick && "cursor-default pointer-events-none",
              )}
            >
              {item.icon && <item.icon />}
              <span>{item.title}</span>
            </SidebarMenuButton>

            <SidebarMenuSub>
              {item.items?.map((subItem) => (
                <SidebarMenuSubButton
                  key={subItem.title}
                  isActive={subItem.isActive}
                  onClick={subItem.onClick}
                  tooltip={subItem.title}
                >
                  {subItem.icon && <subItem.icon />}
                  <span>{subItem.title}</span>
                </SidebarMenuSubButton>
              ))}
            </SidebarMenuSub>
          </SidebarMenuItem>
        ))}
      </SidebarMenu>
    </SidebarGroup>
  );
};
